import styled from 'styled-components'

export const StyledInvoiceCard = styled.div``

export const InvoiceCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
`

export const InvoiceCardList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${props => props.theme.spacing.default};
  margin-top: ${props => props.theme.spacing.medium};
`

export const InvoiceCardItem = styled.button<{ checked: boolean }>`
  background-color: ${props => (props.checked ? props.theme.colors.secondary[100] : 'transparent')};
  border-radius: ${props => props.theme.radius.medium};
  border: 1px solid
    ${props => (props.checked ? props.theme.colors.secondary[100] : props => props.theme.colors.black[200])};
  padding: ${props => props.theme.spacing.medium};

  * {
    pointer-events: none;
  }
`

export const CheckboxInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const RouteList = styled.div`
  margin-top: ${props => props.theme.spacing.default};
  white-space: pre-wrap;
`
